function getUserType () {

	switch (window.top.utag_data?.user_type.trim().toLowerCase()) {

		case 'none':
			return 'Anonymous';
		case 'consumer':
			return 'Consumer';
		case 'professional':
			return 'Pro';
		case 'employee':
			return 'Employee';
		default:
			return '';

	}

}

export default getUserType;
